import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Switch } from '@mui/material';

const PublishToggle = ({ checked, ...props }) => {
  return (
    <FormControlLabel
      {...props}
      control={<Switch checked={checked} />}
      label='Public Access'
    />
  );
};

export default React.memo(PublishToggle);

PublishToggle.propTypes = {
  checked: PropTypes.bool,
};
